import type { BreadcrumbsPropOnItemClick } from '@consta/uikit/Breadcrumbs'
import { Breadcrumbs } from '@consta/uikit/Breadcrumbs'
import type { FC } from 'react'

import css from './Navigation.css'
import type { Step } from './types'
import { useStepController, useStepControllerMethods } from './useStepController'

export const Navigation: FC = () => {
  const { stepPath } = useStepController()
  const { goToStep } = useStepControllerMethods()

  const handleItemClick: BreadcrumbsPropOnItemClick<Step> = ({ id }) => {
    goToStep(id)
  }

  if (stepPath.length === 1) {
    return null
  }

  return (
    <Breadcrumbs
      className={css.navigation}
      items={stepPath}
      size="xs"
      onItemClick={handleItemClick}
    />
  )
}
